import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleFooterLayout } from '@user/layouts/SimpleFooterLayout';
import { RequestForm } from './RequestForm';
import { useNavigate, useLocation } from 'react-router';
import { ResetForm } from './ResetForm';
import { FlatButton } from '@framework/ui/atoms';
import BalusLogo from '@assets/balus-logo-brand-horizontal.svg';

export const PasswordResetPage: React.FC<unknown> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const token = useMemo(() => new URLSearchParams(location.search).get('token'), [location]);
  const success = useMemo(() => new URLSearchParams(location.search).get('success'), [location]);

  // パスワード変更に成功した際のハンドリング
  const handleResetSuccess = useCallback(() => {
    // クエリパラメータでパスワード変更の情報を記録する
    // ログイン中ユーザの情報が変化した際に、セッション管理の最上位コンポーネントでコンポーネントの再生成が行われる。
    // そのとき、配下コンポーネントの state は全てリセットされるため、URLパラメータで状態を保持する。
    const params = new URLSearchParams();
    params.set('success', 'true');
    navigate({ search: params.toString() }, { replace: true });
  }, [navigate]);

  const handleMoveHome = useCallback(() => {
    window.location.href = '/';
  }, []);

  return (
    <SimpleFooterLayout>
      <div className="mx-auto flex flex-col items-center px-4 pb-8 pt-16 md:container">
        <img src={BalusLogo} className="w-64" />

        <div className="py-8 text-3xl font-bold">{t('auth.passwordReset.pageTitle')}</div>

        <div className="rounded-lg border border-gray-500 p-8" style={{ width: '600px' }}>
          {success ? (
            <>
              <div className="text-2xl font-bold">{t('auth.passwordChanged.message')}</div>
              <div className="pt-8">{t('auth.passwordReset.successDescription')}</div>

              <div className="pb-8 pt-16 text-center">
                <FlatButton className="px-16" color="brand" onClick={handleMoveHome}>
                  {t('auth.accountConnected.goHome')}
                </FlatButton>
              </div>
            </>
          ) : (
            <>{token ? <ResetForm resetTokenId={token} onResetSuccess={handleResetSuccess} /> : <RequestForm />}</>
          )}
        </div>
      </div>
    </SimpleFooterLayout>
  );
};
